const config = {
	pageSize: 24,
	goalsWidth: 344,
	topLevelGoalCardHeight: 273,
	baseURL: "/company/goals/alignment/",
	pageTitle: "Goal Alignment",
};

export default config;
